// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__Nzikw","herotextbox":"Hero_herotextbox__30NQt","about":"Hero_about__2rCRA","contact":"Hero_contact__2UtOS"};